'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = require('./app.html');

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* @ngInject */
var AppConfig = function AppConfig($stateProvider, $urlRouterProvider, $translateProvider, $translatePartialLoaderProvider, RestangularProvider, $ionicConfigProvider, stripeProvider, ChartJsProvider, $opbeatProvider, $compileProvider) {

    if (ionic.Platform.isIOS()) {
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|sms|tel|geo|ftp|mailto|file|ghttps?|ms-appx-web|ms-appx|x-wmapp0|ionic|chrome-extension):/);
        $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|file|content|blob|ms-appx|ms-appx-web|x-wmapp0|ionic):|data:image\//);
    }

    $stateProvider.state('home', {
        url: '/',
        template: _app2.default,
        controller: 'AppController',
        controllerAs: 'app',
        params: { showHelp: null }
    });

    $urlRouterProvider.otherwise('/login');

    // Configuration: Default view change
    $ionicConfigProvider.views.transition('platform');
    $ionicConfigProvider.backButton.text('').icon('ion-ios-arrow-left').previousTitleText(false);
    $ionicConfigProvider.navBar.transition('none');
    $ionicConfigProvider.views.transition('none');

    // make horizontal scrolling possible in ios without preventung the vertical scroll just works by setting .jsScrolling to false but then the rest (like scrolling input) won't work
    $ionicConfigProvider.scrolling.jsScrolling(true);

    // Configuration: Restangular
    // Set REST service base URL

    if (window.location.href.match('advinda-app-staging.herokuapp.com')) {
        //console.log('Staging environment');
        RestangularProvider.setBaseUrl('https://advinda-investor-cloud-stage.herokuapp.com');
        $opbeatProvider.config({
            orgId: '7ddff5796d6e401d942d65aba42686cc',
            appId: 'aee318aa8a'
        });
        // Configure stripe publishable key
        stripeProvider.setPublishableKey('pk_test_O0f3TcPjymHtuPqRLp6XniAp');
    } else if (window.location.href.match('advinda-app-dev.herokuapp.com') || window.location.href.match('localhost')) {
        //console.log('Development environment');
        RestangularProvider.setBaseUrl('https://advinda-investor-cloud-dev.herokuapp.com');
        // Configure stripe publishable key
        stripeProvider.setPublishableKey('pk_test_O0f3TcPjymHtuPqRLp6XniAp');
    } else {
        //console.log('Production environment');
        RestangularProvider.setBaseUrl('https://advinda-investor-cloud.herokuapp.com');
        // Configure stripe publishable key
        stripeProvider.setPublishableKey('pk_live_mYaZ98IiaCeCbkXTkOpycrhZ');
        $opbeatProvider.config({
            orgId: '132016af86104580baee9c2ec30eefdf',
            appId: '153887e968'
        });
    }

    // Configuration: Translate
    // Sanitize strategy
    $translateProvider.useSanitizeValueStrategy(null);

    // Add parts
    $translatePartialLoaderProvider.addPart('common');
    $translatePartialLoaderProvider.addPart('navigation');
    $translatePartialLoaderProvider.addPart('users');
    $translatePartialLoaderProvider.addPart('dashboard');
    $translatePartialLoaderProvider.addPart('campaigns');
    $translatePartialLoaderProvider.addPart('contacts');
    $translatePartialLoaderProvider.addPart('investors');
    $translatePartialLoaderProvider.addPart('error-messages');
    $translatePartialLoaderProvider.addPart('selections');
    $translatePartialLoaderProvider.addPart('settings');
    $translatePartialLoaderProvider.addPart('tasks');
    $translatePartialLoaderProvider.addPart('team');
    $translatePartialLoaderProvider.addPart('email');
    $translatePartialLoaderProvider.addPart('cart');
    $translatePartialLoaderProvider.addPart('imprint');
    $translatePartialLoaderProvider.addPart('rfps');

    // Set translation file location
    $translateProvider.useLoader('$translatePartialLoader', {
        urlTemplate: 'assets/i18n/{part}/{lang}.json'
    });

    // Set preferred & fallback language
    $translateProvider.preferredLanguage('en_EN');
    $translateProvider.fallbackLanguage('en_EN');
};

exports.default = AppConfig;


/** WEBPACK FOOTER **
 ** ./src/app/app.config.js
 **/